export const GRANTED_PERM = "granted";
export const BLOCKED_PERM = "blocked";
export const REQUESTED_PERM = "requested";
export const UNREQUESTED_PERM = "unrequested";
